import { ReactComponent as Logo } from "../../assets/images/Logo-secondary.svg";
import { ReactComponent as Insta } from "../../assets/icons/Instagram.svg";
import { ReactComponent as Facebook } from "../../assets/icons/Facebook.svg";
import { ReactComponent as Twitter } from "../../assets/icons/Twitter.svg";
import Button from "../../components/button";
import { t } from "i18next";
import { Link } from "react-router-dom";


const Footer=()=> {

    const navigateToPrivacy=()=> {
        window.open("https://app.termly.io/policy-viewer/policy.html?policyUUID=5e62e91d-5048-404b-a29b-bbcd95345df8", "_blank")
    }
    return (
    <section className="home-container !bg-banner-tertiary !bg-contain  !bg-black !h-auto !bg-bottom   ">
    <div className="px-16 xs:px-4 py-16 xs:py-16 space-y-16">

        <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 sm:gap-8 items-center" >
            <div className="flex flex-col gap-8 items-start">
                <Logo className="max-h-[77px] sm:h-[40px] w-auto" />
                {/* <div className=" space-x-4">
                    <Button
                        className="block  w-auto bg-blue"
                        // loading={isLoading}
                        type="submit"
                    >
                        {t("Signin")}
                    </Button>
                    <Button
                        className="block  w-auto bg-blue"
                        // loading={isLoading}
                        type="submit"
                    >
                        {t("Signup")}
                    </Button>
                </div> */}

                <div className=" flex gap-4 items-center">
                    <Insta />
                    <Facebook />
                    <Twitter />

                </div>

            </div>
            <div className="grid grid-cols-2">
                <Link to="/?tab=contactUs" className="-mx-3 block font-semibold rounded-lg px-3 py-2  text-xl md:text-base sm:text-sm   text-white  leading-7 ">
                    Contact us
                </Link>

                <Link to={'/fraud-prevention'} className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base sm:text-sm font-normal  text-white  leading-7 ">
                    Fraud Prevention
                </Link>
                {/* <Link to={'/termsofuse'} className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base sm:text-sm font-normal  text-white  leading-7 ">
                    Terms of use
                </Link> */}
                {/* <Link to={'/termsOfSale'} className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base sm:text-sm font-normal  text-white  leading-7 ">
                    Terms of sale
                </Link> */}
                {/* <Link to={'/financialDisclosure'} className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base sm:text-sm font-normal  text-white  leading-7 ">
                    Financial disclosure
                </Link> */}
                <Link to={'/afffiliateDisclosure'} className="-mx-3 block rounded-lg px-3 py-2  text-xl md:text-base sm:text-sm font-normal  text-white  leading-7 ">
                    Affiliate disclosure
                </Link>
            </div>
        </div>

        <hr className="w-full border-gray-300 opacity-25 border-solid px-16" />
        <div className="flex sm:flex-col sm:gap-4 items-center justify-between ">
            <p className="text-sm text-white">© 2024 vizion. All rights reserved.</p>
            <div className="flex items-center gap-4">
                <Link onClick={()=> navigateToPrivacy()} to={''} className="text-sm text-white">Privacy Policy </Link> 
                <Link to={'/refund-policy'} className="text-sm text-white">Refund Policy </Link> 
            {/* <Link to={'/termsAndConditions'} className="text-sm text-white">Terms of Service </Link>
            */}
            <p className="text-sm text-white">Cookies</p>
            </div>
        </div>
    </div>
</section>
)
}

export default Footer;